var _excluded = ["membershipSessionToken", "request"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
import { request as baseRequest } from "@xo-union/fetch-request-builder";
import configure from "./configure/index.js";
var _request = /*#__PURE__*/new _WeakMap();
var WeddingAPIClient = /*#__PURE__*/function () {
  function WeddingAPIClient() {
    _classCallCheck(this, WeddingAPIClient);
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$membershipSessi = _ref4.membershipSessionToken,
      membershipSessionToken = _ref4$membershipSessi === void 0 ? '' : _ref4$membershipSessi,
      _ref4$request = _ref4.request,
      request = _ref4$request === void 0 ? baseRequest : _ref4$request,
      config = _objectWithoutProperties(_ref4, _excluded);
    _classPrivateFieldInitSpec(this, _request, {
      writable: true,
      value: void 0
    });
    var _configure = configure(config),
      host = _configure.host,
      apiKey = _configure.apiKey;
    _classPrivateFieldSet(this, _request, request.host(host).query({
      api_key: apiKey
    }).set('MEMBERSHIP-SESSION-TOKEN', membershipSessionToken).readJsonBody());
  }
  _createClass(WeddingAPIClient, [{
    key: "getDecisions",
    value: function getDecisions(weddingID) {
      return _classPrivateFieldGet(this, _request).get("/weddings/".concat(weddingID, "/decisions"));
    }
  }, {
    key: "upsertDecisions",
    value: function upsertDecisions(weddingID, _ref) {
      var decisions = _ref.decisions;
      return _classPrivateFieldGet(this, _request).put("/weddings/".concat(weddingID, "/decisions")).send({
        decisions: decisions
      }).set('Content-Type', 'application/json');
    }
  }, {
    key: "getWeddingById",
    value: function getWeddingById(weddingID) {
      return _classPrivateFieldGet(this, _request).get("/weddings/".concat(weddingID));
    }
  }, {
    key: "getWeddingByMemberId",
    value: function getWeddingByMemberId(memberID) {
      return _classPrivateFieldGet(this, _request).get("/members/".concat(memberID, "/wedding"));
    }
  }, {
    key: "upsertWedding",
    value: function upsertWedding(_ref2) {
      var wedding = _ref2.wedding;
      return _classPrivateFieldGet(this, _request).put('/weddings').set('Content-Type', 'application/json').send({
        wedding: wedding
      });
    }
  }, {
    key: "getBookings",
    value: function getBookings(memberID) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var urlBase = "/member/".concat(memberID, "/bookings");
      var requestUrl = options.category_code ? "".concat(urlBase, "/").concat(options.category_code) : urlBase;
      return _classPrivateFieldGet(this, _request).get(requestUrl);
    }
  }, {
    key: "upsertBooking",
    value: function upsertBooking(_ref3) {
      var booking = _ref3.booking;
      return _classPrivateFieldGet(this, _request).put("/bookings").send({
        booking: booking
      }).set('Content-Type', 'application/json');
    }
  }, {
    key: "deleteBooking",
    value: function deleteBooking(bookingId) {
      return _classPrivateFieldGet(this, _request).del("/bookings/".concat(bookingId));
    }
  }, {
    key: "getDecisionSchemas",
    value: function getDecisionSchemas() {
      return _classPrivateFieldGet(this, _request).get("/decision_schemas");
    }
  }]);
  return WeddingAPIClient;
}();
export { WeddingAPIClient as default };